const Posts = {

	init(className) {

		$(className).each(function() {

			var wrapper = $(this);

			$('.item .btns .btn', wrapper).each(function() {

				var link = $(this),
					links = link.parent(),
					content = link.parents('.item').find('.content');

				link.click(function() {
					content.toggleClass('is_collapsed');

					if (link.hasClass('is_collapsed')) {
						link.text('Show More');
					} else {
						link.text('Show Less')
					}

				});

				if (content.height() > 246) {
					content.addClass('is_collapsed');
					links.addClass('is_visible')
				}

			});

		});

	}

};

export default Posts;